//write code for leads
import { getCvs } from "./services";
// Action Types
export const GET_CVDATA_REQUEST = "GET_CVDATA_REQUEST";
export const GET_CVDATA_SUCCESS = "GET_CVDATA_SUCCESS";
export const GET_CVDATA_FAILURE = "GET_CVDATA_FAILURE";
// Action Creators
export const getCvsRequest = () => {
    return {
        type: GET_CVDATA_REQUEST,
    };
}

export const getCvsSuccess = (leads) => {
    return {
        type: GET_CVDATA_SUCCESS,
        payload: leads,
    };
}

export const getCvsFailure = (error) => {
    return {
        type: GET_CVDATA_FAILURE,
        payload: error,
    };
}

export const getCvsAction = () => async (dispatch) => {
    try {
        dispatch(getCvsRequest());
        const response = await getCvs();
        dispatch(getCvsSuccess(response.data));
    } catch (error) {
        console.log(error);
        dispatch(getCvsFailure(error.message));
    }
}